var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuedates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99965 3.16668C4.74765 3.16668 1.99965 5.91468 1.99965 9.16668C1.99965 12.4187 4.74765 15.1667 7.99965 15.1667C11.2523 15.1667 13.9997 12.4187 13.9997 9.16668C13.9997 5.91468 11.2523 3.16668 7.99965 3.16668ZM11.333 9.83334H7.33299V5.83334H8.66632V8.50001H11.333V9.83334ZM13.5277 4.97201L11.521 2.97201L12.4623 2.02734L14.469 4.02734L13.5277 4.97201ZM3.52099 2.02934L4.46632 2.97068L2.47299 4.97068L1.52832 4.02868L3.52099 2.02934Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuedates);
export default __webpack_public_path__ + "static/media/duedates.51efba098d3e79eef278829c23085073.svg";
export { ForwardRef as ReactComponent };